import axios from 'axios';

export const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
            ? process.env.REACT_APP_API_BASE_URL_PROD 
            : process.env.REACT_APP_API_BASE_URL_DEV,
  headers: {
    'Content-Type': 'application/json'
  },
})

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  },
);